import { LitElement } from '@polymer/lit-element/lit-element';
import { ZuiBaseMixin } from './zui-base-mixin';

class ZuiBaseElement extends ZuiBaseMixin(LitElement) {}

export { ZuiBaseElement };